import {
  BusinessGetResponseType,
  OrderGetResponseType,
} from "@sellar-io/api-v2/types";
import { Button } from "@sellar-io/components";
import { SupplierOnly } from "../../../../components";
import { Alert } from "../../../../components/alert/Alert";
import { BadPayerWarning } from "../../../../components/badPayerWarning/BadPayerWarning";
import { ConsolidatedBanner } from "../../../../components/consolidatedBanner/ConsolidateBanner";
import { OrderShipmentStates } from "../../../../components/newOrderSummary/OrderShipmentStates";
import { OpeningOrderFeeLabel } from "../../../../components/openingOrderFee/OpeningOrderFeeLabel";
import { OrderContentConnectionsType } from "../OrderContent";
import { OrderRefundedAlert } from "../../Alerts/OrderRefundedAlert";
import { SellarDistributionSupplierCutOffAlertContainer } from "../../Alerts/SellarDistributionSupplierCutOffAlert";

type OrderAlertBannersProps = {
  order: OrderGetResponseType;
  connection?: OrderContentConnectionsType;
  business: BusinessGetResponseType;
  defaultPriceTierName: string | undefined;
  userEmail: string | undefined;
  userName: string | undefined;
};

const typeformFallback = "xxxxx";

export const OrderAlertBanners = ({
  order,
  connection,
  business,
  defaultPriceTierName,
  userEmail,
  userName,
}: OrderAlertBannersProps) => {
  return (
    <>
      {!connection?.approved &&
        business.Supplier &&
        !order.confirmedAt &&
        !order.cancelledAt && (
          <Alert
            type={"information"}
            title={"New customer!"}
            message={`${order.Retailer.Business.name} are requesting an order from you for the first time on Sellar. The order was placed on your default price tier: ${defaultPriceTierName}. You can make edits to the prices, products and quantities before confirming.`}
          />
        )}
      <SupplierOnly>
        {!order.cancelledAt &&
          order.confirmedAt &&
          ["ups", "parcelforce", "apc", "dx", "dxDropOff"].includes(
            order.fulfillmentType,
          ) && <OrderShipmentStates order={order} connection={connection} />}
      </SupplierOnly>
      {!!order.refundedAmount && (
        <OrderRefundedAlert
          refundAmount={order.refundedAmount}
          className={"w-full"}
        />
      )}
      <SupplierOnly>
        {Boolean(order.confirmedAt) && order.fulfillmentType === "haulier" ? (
          <ConsolidatedBanner
            title={"Ship this order with Pallet Track"}
            description={""}
          >
            <div className="flex w-full flex-wrap gap-2 md:w-auto">
              <Button
                onClick={() =>
                  window.open(
                    `https://sellar.typeform.com/to/yDlhVnzI#supplier_name=${order.Supplier.Business.name}&buyer_name=${order.Retailer.Business.name}&delivery_address=${Object.values(order.DeliveryAddress).join()}&order_id=${order.id}&collection_address=${Object.values(order.Supplier.Business.CollectionAddress || order.Supplier.Business.DeliveryAddress).join()}&requested_by_name=${userName}&requested_by_email=${userEmail}&supplier_phone=${order.Supplier.Business.phoneNumber ?? typeformFallback}&buyer_phone=${order.retailerContactSmsNumber ?? typeformFallback}&buyer_email=${order.Retailer.Business.email}`,
                    "_blank",
                  )
                }
                color={"secondary"}
              >
                Book Pallet Delivery
              </Button>
              <Button
                color={"tertiary"}
                onClick={() =>
                  window.open(
                    "https://intercom.help/sellario/en/articles/12417238-supplier-guide-pallets-with-pallettrack",
                    "blank",
                  )
                }
              >
                View rates
              </Button>
            </div>
          </ConsolidatedBanner>
        ) : null}
        {order.OpeningOrderFee && (
          <OpeningOrderFeeLabel fullLabel={true} fee={order.OpeningOrderFee} />
        )}
        <BadPayerWarning
          flaggedAsBadPayer={order.Retailer.flaggedAsBadPayer}
          paymentType={order.paymentType}
        />
      </SupplierOnly>
      <SellarDistributionSupplierCutOffAlertContainer
        order={{
          ...order,
          supplierFinalisationCutOffAt:
            order.OrderSellarDistributionMeta?.supplierFinalisationCutOffAt ??
            null,
        }}
        mode="alert"
      />
    </>
  );
};
